import { MessageCircle, Phone, Wrench } from "lucide-react";
import { COMPANY } from "../lib/constants";
import { createWhatsAppLink } from "../lib/whatsapp";

export function WhatsAppButton() {
  return (
    <>
      <a className="floating-whatsapp" href={createWhatsAppLink("Olá, preciso de um guincho.")} aria-label="Chamar no WhatsApp" data-testid="floating-whatsapp-button"><MessageCircle size={20} /><span>Chamar no WhatsApp</span></a>
      <nav className="mobile-cta-bar" aria-label="Ações rápidas" data-testid="mobile-cta-bar">
        <a href={COMPANY.phoneHref} data-testid="mobile-cta-phone"><Phone size={16} /> Ligar</a>
        <a href={createWhatsAppLink("Olá, preciso de um guincho.")} data-testid="mobile-cta-whatsapp"><MessageCircle size={16} /> WhatsApp</a>
        <a href="#servicos" data-testid="mobile-cta-services"><Wrench size={16} /> Serviços</a>
      </nav>
    </>
  );
}